<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-25 md-medium-size-50 md-small-size-100">
      <md-card v-if="email !== null">
        <md-card-header>
          <h4 class="title">Setup your password</h4>
        </md-card-header>
        <md-card-content>
          <md-field class="md-form-group">
            <md-icon>lock_outline</md-icon>
            <label>Password</label>
            <md-input
              ref="password"
              v-model="new_password"
              type="password"
              @keyup.enter="submitOnEnter"
            ></md-input>
          </md-field>
          <md-field class="md-form-group">
            <md-icon>lock_outline</md-icon>
            <label>Confirm Password</label>
            <md-input
              ref="password_confirmation"
              v-model="new_password_confirm"
              type="password"
              @keyup.enter="submitOnEnter"
            ></md-input>
          </md-field>
          <div class="button-container">
            <md-button
              slot="footer"
              :disabled="loading"
              class="md-primary md-round mt-4 btn-login"
              @click="setupPassword"
            >
              <span v-if="!loading" key="login">Change Password</span>
              <span v-else key="spinner">
                <md-progress-spinner
                  id="spinner"
                  :md-diameter="20"
                  :md-stroke="3"
                  md-mode="indeterminate"
                />
              </span>
            </md-button>
          </div>
        </md-card-content>
      </md-card>

      <md-card
        v-if="error !== null"
        class="md-layout-item md-size-100 md-medium-size-100 md-error text-danger"
      >
        <label>{{ error }}</label>
      </md-card>

      <md-card
        v-if="info !== null"
        class="md-layout-item md-size-100 md-medium-size-100 info"
      >
        <label>
          {{ info }}
          <div class="button-container">
            <md-button
              v-if="showLogin"
              slot="footer"
              href
              class="md-primary md-round mt-4"
              @click="login()"
              >Go to login</md-button
            >
          </div>
        </label>
      </md-card>

      <md-card v-if="loading">
        <span>
          processing, please wait...
          <md-progress-spinner
            id="spinner"
            :md-diameter="20"
            :md-stroke="3"
            md-mode="indeterminate"
          />
        </span>
      </md-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      showLogin: false,
      loading: false,
      info: null,
      error: null,
      email: null,
      new_password: null,
      new_password_confirm: null,
      token: null
    }
  },
  mounted() {
    this.token = this.$route.query.token
    this.password = this.$route.query.password
    this.email = this.$route.query.email
    this.veryToken()
  },

  methods: {
    submitOnEnter() {
      this.setupPassword()
    },

    notifyVueError(text) {
      this.$notify({
        message: '<b>Ups! </b>' + text + '',
        icon: 'add_alert',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'danger'
      })
    },
    login() {
      this.$router.push({
        name: 'Login'
      })
    },
    passwordConfirmed() {
      return this.new_password === this.new_password_confirm
    },
    veryToken() {
      console.log(this.$route.query)
      let url = `${process.env.VUE_APP_API_URL}/user/confirm/email`

      //this.loading = true
      axios
        .post(
          url,
          {
            email: this.email,
            password: this.password,
            token: this.token
          },
          {
            headers: {
              Accept: 'application/json'
            }
          }
        )
        .then(response => {
          this.loading = false
          console.log({ response })

          //if the request was successful then set the params
          let data = response.data
          this.token = data.token
          this.email = data.email
          this.error = null
        })
        .catch(error => {
          console.error(error)
          this.loading = false
          this.error = 'Sorry, this link is no longer valid!'
          this.info = null
        })
    },

    setupPassword() {
      this.error = null
      if (!this.passwordConfirmed()) {
        this.notifyVueError('passwords does not match!')
        return
      }
      let url = `${process.env.VUE_APP_API_URL}/user/confirm/change_password`
      this.loading = true
      axios
        .post(
          url,
          {
            email: this.email,
            new_password: this.new_password,
            token: this.token
          },
          {
            headers: {
              Accept: 'application/json'
            }
          }
        )
        .then(response => {
          console.log(response)
          this.loading = false
          this.error = null
          this.email = null
          this.token = null
          this.new_password = null
          this.info = 'Your account has been activated, Now you can login'
          this.showLogin = true
        })
        .catch(error => {
          console.error(error)
          this.loading = false
          this.error = 'Sorry, this link is no longer valid!'
          this.info = null
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.md-error > label {
  padding: 20px;
  font-weight: 600;
}
.info > label {
  padding: 20px;
  font-weight: 600;
}

.btn-login {
  margin-bottom: 30px !important;
  height: auto !important;
}
.md-progress-spinner.md-theme-default .md-progress-spinner-circle {
  stroke: #ffffff;
}
</style>
